import dayjs from 'dayjs';
import { InformationPad } from '../../../components/shared';
import { formatNumberOrReturnZero, getCurrency } from '../../../utils/common-methods';

const MachineDetailView = ({ machineInfo }) => {
  if (machineInfo) {
    machineInfo = {
      ...machineInfo,
      price: machineInfo?.price || 0,
    };
  }
  const fields = [
    { label: 'Serial Number', value: machineInfo?.serialNumber },
    { label: 'Asset ID', value: machineInfo?.id },
    { label: 'Legacy Asset ID', value: machineInfo?.legacyAssetId },
    { label: 'Status', value: machineInfo?.status?.title },
    { label: 'No.of Plays', value: machineInfo?.numberOfPlays || 0 },
    {
      label: 'Installed Date',
      value: machineInfo?.installedDate
        ? dayjs(machineInfo.installedDate).format('MM/DD/YYYY')
        : machineInfo?.installedDate,
    },
    {
      label: 'Uninstall Date',
      value: machineInfo?.uninstalledDate
        ? dayjs(machineInfo.uninstalledDate).format('MM/DD/YYYY')
        : machineInfo?.uninstalledDate,
    },
    { label: 'Model Name', value: machineInfo?.model?.title },
    {
      label: 'In Effect From',
      value: machineInfo?.inEffectFrom
        ? dayjs(machineInfo?.inEffectFrom).format('MM/DD/YYYY')
        : machineInfo?.inEffectFrom,
    },
    {
      label: 'In Effect To',
      value: machineInfo?.inEffectTo ? dayjs(machineInfo?.inEffectTo).format('MM/DD/YYYY') : '',
    },
    { label: 'Game Reading', value: machineInfo?.gameMeter || 0 },
    {
      label: 'Cost Per Play',
      value: `${getCurrency(machineInfo?.currency?.abbreviation || 'USD')}${formatNumberOrReturnZero(
        machineInfo?.costPerPlay,
      )}`,
    },
    { label: 'Clicks Per Play', value: machineInfo?.clicksPerPlay || 0 },
    {
      label: 'Price',
      value: `${getCurrency(machineInfo?.currency?.abbreviation || 'USD')}${formatNumberOrReturnZero(
        machineInfo?.price,
      )}`,
    },
    { label: 'Sub Location', value: machineInfo?.sublocation?.name },
  ];

  return <InformationPad data={fields} />;
};
export default MachineDetailView;
